import { Fragment, useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ErrorMsg } from '../error-msg/error-msg';
import { OtherRecommendComment } from '../other-recommend-comment';
import { useTranslations } from 'next-intl';

interface RecommendCheckListProps {
	field : any;
	register: any;
	error?: any;
	reset: any;
	setError: any;
	clearErrors: any;
	recommendScore: number;
	recommendType: boolean;
	getValues: any;
	setFocus: any;
}

export const  RecommendCheckList = ({ 
	field, 
	register,
	error, 
	clearErrors,
	recommendScore, 
	recommendType,
	getValues,
	setFocus,
} : RecommendCheckListProps) => {
	const t = useTranslations('General');

	const { setValue, watch } = useFormContext();
	const previousType = useRef(recommendType)
	const otherRecommendCommentRef = useRef('');

	const checkedOptions = watch('recommendOptions')
	const checkedArray = checkedOptions.trim() === '' ? [] : checkedOptions.split(',')
		.map((item: string) => parseInt(item.trim(), 10))
		.filter((item: number) => !isNaN(item));

	const [checkedItems, setCheckedItems] = useState(checkedArray);

	useEffect(() => {
		if (checkedOptions.trim() === '') {
			setCheckedItems([])
		}
	}, [checkedOptions])
	
	const CheckListOpions = {
		Satisfied: [
			{ no: 1, title: t('lbl_GSabaSurveyChoice01') },
			{ no: 2, title: t('lbl_GSabaSurveyChoice02') },
			{ no: 3, title: t('lbl_GSabaSurveyChoice03') },
			{ no: 4, title: t('lbl_GSabaSurveyChoice04') },
			{ no: 5, title: t('lbl_GSabaSurveyChoice05') },
			{ no: 6, title: t('lbl_GSabaSurveyChoice06') },
			{ no: 7, title: t('lbl_GSabaSurveyChoice07') },
		], 
		Unsatisfied: [
			{ no: 8, title: t('lbl_GSabaSurveyChoice08') },
			{ no: 9, title: t('lbl_GSabaSurveyChoice09') },
			{ no: 10, title: t('lbl_GSabaSurveyChoice10') },
			{ no: 11, title: t('lbl_GSabaSurveyChoice11') },
			{ no: 12, title: t('lbl_GSabaSurveyChoice12') },
			{ no: 13, title: t('lbl_GSabaSurveyChoice13') },
			{ no: 14, title: t('lbl_GSabaSurveyChoice07') },		
		]
	}
	
	const DisplayCheckList = recommendScore > 3 ? CheckListOpions.Satisfied : CheckListOpions.Unsatisfied

	useEffect(() => {
		if (recommendType !== previousType.current || recommendScore===0) {
			setCheckedItems([])
			// TODO:待優化
			setValue(field.name, '', { shouldValidate: true });
			setValue('otherRecommendComment', '', { shouldValidate: true });
			otherRecommendCommentRef.current = '';
		}
		previousType.current = recommendType;
	}, [recommendType, recommendScore])	

	const updateCheckedItem = (no: number) => {
		const formData = getValues();
		const otherRecommendCommentInput = formData.otherRecommendComment;
		let updatedList = [...checkedItems];
		
		if (checkedItems.includes(no)) {
			updatedList = updatedList.filter(data => data !== no);
		} else {
			updatedList.push(no);
		}
		setCheckedItems(updatedList)
		setValue(field.name, updatedList.join(','), { shouldValidate: true });
		
		const hasCheckedOther = (updatedList.includes(7) || updatedList.includes(14))
		handleOtherComment(hasCheckedOther, otherRecommendCommentInput)
	};

	const handleOtherComment = (isChecked:boolean, inputValue: string) => {
		if (!isChecked) {
			clearErrors('otherRecommendComment')
			setValue('otherRecommendComment', '', { shouldValidate: true });
			otherRecommendCommentRef.current = '';
			return
		}
		if (isChecked && !inputValue) {
			setFocus('otherRecommendComment')
		}
	};

	
	const otherCommentInputChange = (value : string) => {
		const isKeyOtherComment = otherRecommendCommentRef.current.length===0 && value.length > 0;
		const hasCheckedOther = (checkedItems.includes(7) || checkedItems.includes(14))
		
		otherRecommendCommentRef.current = value;
		// 如果不是輸入值
		if (!isKeyOtherComment) return;

		if (isKeyOtherComment && !hasCheckedOther) {
			if (recommendType) {
				updateCheckedItem(7)
			} else {
				updateCheckedItem(14)
			}
		}
	}

	return (
		<div className="survey-form__content" data-error={!!error.recommendOptions}>
			{DisplayCheckList.map((item) => (
				<Fragment key={`check_${item.no}`}>
					<div 
						className="survey-form__input" 
						data-selected={checkedItems.includes(item.no) }
						onClick={() => updateCheckedItem(item.no)}
					>
						<span className="survey-form__input-checkbox"></span>
						<span className="survey-form__input-label">
							{item.title}
						</span>
					</div>
					{(item.no === 7 || item.no === 14) ?  
						<OtherRecommendComment
							register={register}
							error={error}
							no={item.no}
							inputChange={otherCommentInputChange}
						/>
						: null}
				</Fragment>
			))}
			<input 
				key={`checklist_${field.name}`}
				type="text"
				{...field}
				hidden
				readOnly
			/>
			{error.recommendOptions?.message && 
				<ErrorMsg 
					msg={error.recommendOptions.message} 
				/>}
		</div>
	)
}